const section = {
  about: 'About me',
  projects: 'My Work',
  blogs: 'Blogs',
  skills: 'Skills',
  contact: `I’m always up for adventure and opportunities.\nFeel free to say hello via`,
};

export default section;
